<div class="row">
  <div class="col-md-6">
    <app-payment-summary-dashboard
      [project]="project"
    ></app-payment-summary-dashboard>
  </div>
  <div class="col-md-6">
    <app-project-costs [project]="project"></app-project-costs>
  </div>
</div>
